import React from "react";
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import  Close from "@material-ui/icons/Close";

const useStyle = makeStyles(theme => ({
  dialogTitle: {
    background: theme?.palette?.ePrimary?.base + " !important",
    color: theme?.palette?.eWhite?.base,
    padding: "10px 12px 10px 12px"
  },
  warningTitle: {
    background: theme.palette.ePrimary?.base,
    color: theme.palette.eDanger?.dark,
    padding: "10px 12px 10px 12px"
  },
  dialogContent: {
    padding: "3% 3%"
  },
  buttonStyle: {
    backgroundColor: theme?.palette?.ePrimary?.base + " !important",
    color: theme?.palette?.eWhite?.base,
    borderRadius:30,
    fontSize:"0.875rem",
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary.hover + " !important",
      color: theme?.palette?.eWhite?.base + " !important"
    },
    padding: "1% 8%",
  },
  crossButton:{
    color: theme?.palette?.eWhite?.base,
    position: 'absolute',
    right: 0,
    top: 10,
    justifyContent: "end",
  },
}));

export const AppDialog = ({openDialog, handleClose, handleOkClick, title, desc, buttonLabel,warning}) => {
  const styles = useStyle();
  return (
    <>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        disableBackdropClick
      >
        <DialogTitle id="alert-dialog-title" className={warning?styles.warningTitle:styles.dialogTitle}>
          <Typography variant="subtitle1" align="left">
            <b>{title}</b>
          </Typography>
          {
            handleClose && <Button startIcon={<Close />} onClick={handleClose} className={styles.crossButton}></Button>
          }
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
          {desc}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleOkClick}
            variant="contained"
            size="small"
            className={styles.buttonStyle}
            align="right"
          >
            {buttonLabel} 
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
